import { httpClient, apiClient } from "./httpClient";

export default {
  user: () => {
    return httpClient.get("/auth-user");
  },
  ping: () => {
    return httpClient.get("/ping");
  },
};
